import { makeAuthedRequest } from "utils/makeAuthedRequest";
import { useQuery } from "react-query";
import env from "../../environment";

export function useEagleTrackerProfile({ ibo, event, year }) {
  const { data, isLoading, refetch } = useQuery(
    ["eagleDetails", event, year],
    () =>
      makeAuthedRequest(
        `/eagle/detail/ibo/${ibo}/event/${event}/year/${year}`,
        {
          method: "GET",
        },
        env.apiBase
      ).then(async (res) => {
        if (res.ok) {
          return res.json();
        } else {
          throw new Error((await res.json()).message);
        }
      }),
    {
      refetchOnWindowFocus: false,
      staleTime: Infinity,
      cacheTime: Infinity,
    }
  );

  return {
    data,
    isLoading,
    refetch,
  };
}
